import { render } from "./UsersHeader.vue?vue&type=template&id=7277c01f&scoped=true"
import script from "./UsersHeader.vue?vue&type=script&lang=js"
export * from "./UsersHeader.vue?vue&type=script&lang=js"

import "./UsersHeader.vue?vue&type=style&index=0&id=7277c01f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7277c01f"]])

export default __exports__